import { useEffect, useMemo, useState } from 'react';

export const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(false);

    const media = useMemo(() => (typeof window !== 'undefined' ? window.matchMedia(query) : undefined), [query]);

    useEffect(() => {
        if (!media) return;

        const listener = () => setMatches(media.matches);
        window.addEventListener('resize', listener);

        return () => window.removeEventListener('resize', listener);
    }, [media]);

    return media && media.matches !== matches ? media.matches : matches;
};
